var Marionette = require('backbone.marionette');

var CommonUtils = require('../../utils/common-utils.js');


var MergeToPersonDemographicsView = Marionette.View.extend({
    template: require('../../templates/persons/merge-to-person-demographics-view.html'),
    modelEvents: {
        change: 'render'
    },

    ui: {
        birthDate: '#birth-date',
        gender: '#gender',
        restore: '.restore'
    },

    events: {
        'click @ui.restore': 'onRestore',
        'change input[type=text]': 'onInputChange',
        'change input[type=checkbox]': 'onCheckboxChange',
        'change @ui.gender': 'onInputChange'
    },

    templateContext: function () {
        var that = this;
        var bd = that.model.get('object').birthData;
        return {
            birthData: (bd == '' || bd == null || bd == 0 ? '' : that.utils.longToDateTimeFormatted(Number(bd), 'MM/DD/YYYY')),
            mergeToPersonId: that.getOption('mergeToPersonId'),
            mergeToPersonName: that.getOption('mergeToPersonName'),
            isHidden: function(field) {
                return that.getOption('isBeingMerged')(field) ? '' : 'hidden'
            }
        }
    },

    initialize: function (options) {
        this.model.on('change', this.render, this);
        this.model = options.model;
        this.utils = new CommonUtils();
    },

    onRender: function () {

        this.ui.birthDate.datepicker({
            format: 'mm/dd/yyyy',
            clearBtn: true
        }).on('changeDate', function (e) {
            $(this).datepicker('hide');
        });

        var genderSelectize = this.ui.gender.selectize({
            allowEmptyOption: false
        });
    },

    onRestore: function(event) {
        this.triggerMethod('restore:person:demographics', event.target.id.replace('span.', ''));
    },

    onInputChange: function(event) {
        this.triggerMethod('edit:person:demographics', {
            fieldName: event.target.id,
            value: event.target.value
        });
    },

    onCheckboxChange: function(event) {
        this.triggerMethod('edit:person:demographics', {
            fieldName: event.target.id,
            value: event.target.checked
        });
    }
});

module.exports = MergeToPersonDemographicsView;


//////////////////
// WEBPACK FOOTER
// ./app/views/persons/merge-to-person-demographics-view.js
// module id = 480
// module chunks = 0